import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {SpørreskjemaModell} from 'felles-ng2/tjenester/ressurser/generertNg2HttpKlient';
import {SpørreundersøkelseBesvarelseSkjemaKomponent} from 'web-ng2/moduler/spørreundersøkelse/komponenter/spørreundersøkelse-besvarelse-skjema/spørreundersøkelse-besvarelse-skjema';

/**
 * Forhåndsvisning av et spørreskjema slik det vises for respondentene, uten mulighet for å besvare.
 */
@Component({
    selector: 'spoerreskjema-forhaandsvisning',
    templateUrl: 'spørreskjema-forhåndsvisning.html',
    styleUrl: 'spørreskjema-forhåndsvisning.scss',
    host: {'data-testid': 'spoerreskjema-forhaandsvisning'},
    imports: [
        TranslateModule,
        SpørreundersøkelseBesvarelseSkjemaKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpørreskjemaForhåndsvisningKomponent {

    skjema = input.required<SpørreskjemaModell>();

    /** Ikke-redigerbart besvarelsesskjema, opprettes på nytt kun dersom skjemaet endres */
    readonly besvarelsesskjema = computed(() => SpørreundersøkelseBesvarelseSkjemaKomponent.opprettIkkeRedigerbartSkjema(this.skjema()));
}
